import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AiLink } from 'site-modules/shared/components/ai-link/ai-link';
import { NavigationLinks } from './navigation-links';
import { SearchBox } from './search-box';

export function DesktopNavigationLinksCol({
  pathname = '',
  isAppraisalLinkExcluded = false,
  showSearchBar = true,
  withAiLink = true,
}) {
  return (
    <div
      className={classnames('navigation-links-col', {
        'd-flex justify-content-center align-items-center': withAiLink,
      })}
    >
      <NavigationLinks
        className="d-flex flex-row justify-content-around justify-content-md-center align-items-center"
        pathname={pathname}
        renderAppraisalLink={!isAppraisalLinkExcluded}
        withAiLink={withAiLink}
      />
      {showSearchBar && <SearchBox isMobile={false} withAiLink={withAiLink} />}
      {!showSearchBar && withAiLink && <AiLink classes="" />}
    </div>
  );
}

DesktopNavigationLinksCol.propTypes = {
  pathname: PropTypes.string,
  isAppraisalLinkExcluded: PropTypes.bool,
  showSearchBar: PropTypes.bool,
  withAiLink: PropTypes.bool,
};
